module.exports = __webpack_public_path__ + "static/media/who.38b4ec41.jpg";